export const QA_NAME_ENTITY_TAB_FLATS_ADD_NEW = 'entityTabFlatsAddNew'

export const ENTITY_TAB_FLATS_SCALAR_SCOPE_FILTER_KEYS = ['for_building_group']
